<template>
  <b-card>
    <b-row align-h="between">
      <b-col>
        <h4>Ecoulement</h4>
      </b-col>
      <b-col cols="3" class="text-right">
        <b-avatar
          size="32"
          variant="light-primary"
          v-b-tooltip.hover.v-primary
          title="Cet indicateur illustre l’évolution du rythme des ventes via la durée moyenne de vente en mois de la commercialisation des nouveaux programmes sur les 4 dernières années sur le secteur du programme ou adresse sélectionné."
        >
          <feather-icon size="20" icon="HelpCircleIcon" />
        </b-avatar>
      </b-col>
    </b-row>
    <b-row>
      <b-col xl="12">
        <sales-speed-chart :ventesByPeriode="reportData.ventesByPeriode[0]" />
      </b-col>
      <b-col xl="12">
        <sales-speed-array :ventesByPeriode="reportData.ventesByPeriode[0]" />
      </b-col>
      <b-col xl="12">
        <comment-form-text-area
          :enable="reportData.comments.salesSpeed.enable"
          :commentField="reportData.comments.salesSpeed.value"
          v-on:update:comment="reportData.comments.salesSpeed.value = $event"
          v-on:update:enable="reportData.comments.salesSpeed.enable = $event"
          v-on="$listeners"
        />
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import { BCard, BRow, BCol, VBTooltip, BAvatar } from "bootstrap-vue";
import SalesSpeedArray from "./sales-speed-elements/SalesSpeedArray";
import SalesSpeedChart from "./sales-speed-elements/SalesSpeedChart";
import CommentFormTextArea from "../../shared/CommentFormTextArea";

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BAvatar,

    SalesSpeedArray,
    SalesSpeedChart,
    CommentFormTextArea,
  },
  directives: {
    "b-tooltip": VBTooltip,
  },
  props: {
    reportData: {
      type: Object,
      required: true,
    },
  },
};
</script>
